import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TransactionEntityBalanceDTO  {
    _originalTypeClassName = "zERP.BO.TransactionEntityBalanceDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TransactionEntityBalanceDTO.translate = translateService;
}
this.PaymentsAmount = null;
this.PendingPaymentsAmount = null;
this.ReceiptsAmount = null;
this.PendingReceiptsAmount = null;
this.ExpensesCount = null;
this.IncomesCount = null;
this.TransactionEntityBalanceDTOKey = null;
this._key = this.TransactionEntityBalanceDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
PaymentsAmount:any;
PendingPaymentsAmount:any;
ReceiptsAmount:any;
PendingReceiptsAmount:any;
ExpensesCount:any;
IncomesCount:any;
private _TransactionEntityBalanceDTOKey:any;
get TransactionEntityBalanceDTOKey(): any {
    return this._TransactionEntityBalanceDTOKey;
  }
set TransactionEntityBalanceDTOKey(value: any) {
    this._TransactionEntityBalanceDTOKey = value;
    this._key = value;
  }

static Fill(docs: any): any{let transactionEntityBalance = new Domain.TransactionEntityBalanceDTO();
transactionEntityBalance.PaymentsAmount = 0;
transactionEntityBalance.PendingPaymentsAmount = 0;
transactionEntityBalance.ReceiptsAmount = 0;
transactionEntityBalance.PendingReceiptsAmount = 0;
transactionEntityBalance.ExpensesCount = 0;
transactionEntityBalance.IncomesCount = 0;
let expenses = 0;
let incomes = 0;
let results = docs.Results?.linq?.orderBy((r) => r.Date)?.toArray();
let inventoryInvoice = results?.linq?.where((r) => r.DocType == "Inventory Invoice")?.toArray()?.linq?.orderBy((r) => r.Date)?.toArray()?.linq?.where()?.firstOrDefault(null);
if (inventoryInvoice != null) {let index = results?.indexOf(inventoryInvoice);results = results?.linq?.skip(index)?.toArray();}
for (let _idoc = 0; _idoc < (results == null ? 0 : results.length); _idoc++) {let doc = results[_idoc];switch (doc.DocType) {case "Payment":
{
transactionEntityBalance.PaymentsAmount = Joove.Common.safeNumber(transactionEntityBalance?.PaymentsAmount) + Joove.Common.safeNumber(doc.PaymentAmount);break;}
case "IncomePayment":
{
transactionEntityBalance.ReceiptsAmount = Joove.Common.safeNumber(transactionEntityBalance?.ReceiptsAmount) + Joove.Common.safeNumber(doc.TotalIncomeAmount);break;}
case "Expense":
{
expenses = Joove.Common.safeNumber(expenses) + Joove.Common.safeNumber(Math.abs(doc.BalanceUpdate));transactionEntityBalance.ExpensesCount = Joove.Common.safeNumber(transactionEntityBalance?.ExpensesCount) + Joove.Common.safeNumber(1);break;}
case "Income":
{
incomes = Joove.Common.safeNumber(incomes) + Joove.Common.safeNumber(Math.abs(doc.BalanceUpdate));transactionEntityBalance.IncomesCount = Joove.Common.safeNumber(transactionEntityBalance?.IncomesCount) + Joove.Common.safeNumber(1);break;}
case "Inventory Invoice":
{
console.info("Inventory Invoice");expenses = inventoryInvoice.Debt;incomes = inventoryInvoice.Credit;transactionEntityBalance.ExpensesCount = 0;transactionEntityBalance.IncomesCount = 0;break;}
}}
transactionEntityBalance.PendingPaymentsAmount = Joove.Common.safeNumber(expenses) - Joove.Common.safeNumber(transactionEntityBalance?.PaymentsAmount);
transactionEntityBalance.PendingReceiptsAmount = Joove.Common.safeNumber(incomes) - Joove.Common.safeNumber(transactionEntityBalance?.ReceiptsAmount);
return transactionEntityBalance;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.TransactionEntityBalanceDTOKey == null || $this.TransactionEntityBalanceDTOKey == 0;
            }


}